import { configureStore } from '@reduxjs/toolkit'

import { listenerMiddleware } from '@/config/store/listenerMiddleware'
import { ENVIRONMENT } from '@/constants/env'
import { rootApi } from '@/ducks/root.api'
import rootReducer, { RootState } from '@/ducks/root.reducer'

export const setupStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    devTools: ENVIRONMENT !== 'production',
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false
      })
        .concat(rootApi.middleware)
        .prepend(listenerMiddleware.middleware)
  })

const store = setupStore()

export default store

export type AppStore = ReturnType<() => typeof store>
export type AppDispatch = AppStore['dispatch']
